import { asChecked } from './asChecked';
import { asNumber } from './asNumber';
import { withErrorMessage } from './withErrorMessage';
export var asInteger = withErrorMessage(asChecked(asNumber, Number.isInteger), 'integer');
